<script>
  import Chip, { Set, Text } from "@smui/chips";
  import { Icon } from "@smui/common";
  import { get } from "svelte/store";
  import { organizationStore } from "../organizations/organizations";
  import { currentUser } from "./users";

  function getChipName(organizationId) {
    let organization = get(organizationStore).find(
      (org) => org.companyId === organizationId,
    );
    return organization.name.concat(" #", organizationId);
  }
</script>

{#if !$currentUser.allOrganizations}
  {#if $currentUser.organizations === undefined || $currentUser.organizations.length === 0}
    <div class="errortext mdc-form-field mt-2">
      Ten minste een organisatie moet geselecteerd worden als de gebruiker niet
      bevoegd is voor alle organisaties.
    </div>
  {:else}
    <div>
      <Set bind:chips={$currentUser.organizations} let:chip input>
        <Chip {chip}>
          <Text>{getChipName(chip)}</Text>
          <Icon class="material-icons" trailing tabindex="0">cancel</Icon>
        </Chip>
      </Set>
    </div>
  {/if}
{/if}

<style>
  .errortext {
    color: #d41b5d;
  }
</style>
